import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from "@air/primitive-tooltip";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const InfoPanelDetailsSection = /*#__PURE__*/ memo((param)=>{
    let { title, Icon, children, className } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("flex gap-4 border-b border-grey-3 px-2 py-3 [&:last-of-type]:border-none", className),
        children: [
            /*#__PURE__*/ _jsx(Tooltip, {
                label: title,
                side: "left",
                children: /*#__PURE__*/ _jsx(Icon, {
                    className: "mt-0.5 size-4 shrink-0 cursor-pointer text-grey-8"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "w-full",
                children: children
            })
        ]
    });
});
InfoPanelDetailsSection.displayName = "InfoPanelSection";
